var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fields-list',{attrs:{"update-component":_vm.customFieldsUpdateKey,"fields":!!_vm.fields ? _vm.fields : [],"editing-data":_vm.editingData},on:{"update-field":function($event){return _vm.updateField($event.value, $event.field)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bde55f3e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/StockManagement/CustomFieldsTab.vue
// module id = null
// module chunks = 